import { useContext, useEffect, useMemo, useRef, useState } from "react"
import { callautopopulate } from "../../../services/callautopop";
import _ from "underscore";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { Dropdown } from "primereact/dropdown";
import { secondsToHours, timeOptions } from "../../../utils/Helper";
import { useCommon } from "./useCommon";
import { ToastContext } from "../../../context/ToastContext";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import globalFilterStore from "../../../Store/globalFilterStore";

export const useEstimateList = ({ getValuePermission }) => {

    const { getSubProject } = useCommon();
    const { showSuccess, showError, showInfo } = useContext(ToastContext);
    const tagRef = useRef(null);
    const menuRef = useRef(null);
    const [options, setOptions] = useState({ projects: [], bid_seconds: [], issueType: [], apiCall: false });
    const [loader, setLoader] = useState(false);
    const [revoke, setRevoke] = useState({ show: false, data: [] });
    const [selectedData, setSelectedData] = useState({ bid: {}, issue: [] });
    const [rowData, setRowData] = useState([]);
    const [expanded, setExpanded] = useState(true)
    const store = globalFilterStore();
    const { commonFilter, setCommonFilter, projectWiseData, setProjectWiseData } = store;
    const [filterValues, setFilterValues] = useState({ ...commonFilter });
    const [taskDetailsPopup, setTaskDetailsPopup] = useState({ show: false, hoveredId: 0 });

    const columns = [
        {
            key: "",
            label: "",
            checkbox: true,
            hide: getValuePermission("agileplanning_estimation_send_to_review_btn"),
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                const checked = row?.id === "all" ? (_.isEmpty(rowData) ? false : _.every(_.pluck(rowData, "children")?.flatMap(item => item), item => _.pluck(selectedData?.issue, "issue_id")?.includes(item?.issue_id))) : !_.isEmpty(_.findWhere(selectedData?.issue, { issue_id: row?.issue_id }));

                const handleTaskSelection = (row, e) => {
                    if (row?.id === "all") {
                        setSelectedData((prev) => ({ ...prev, issue: e.target?.checked ? [..._.pluck(rowData, "children")?.flatMap(item => item)] : [] }));
                    } else {
                        setSelectedData((prev) => ({ ...prev, issue: e.target?.checked ? [...prev?.issue, row] : _.filter(selectedData?.issue, item => item?.issue_id !== row?.issue_id) }))
                    }
                }

                return (
                    <div className="d-flex justify-content-center">
                        <input type="checkbox" className="input-dd" checked={checked} onChange={(e) => handleTaskSelection(row, e)} />
                    </div>
                );
            },
            style: { width: "3%" }
        },
        {
            key: "issue_key",
            label: "Task ID",
            style: { fontWeight: "500", textAlign: "center", width: "10%" },
            headerStyle: { textAlign: "center" },
            render: (row) => {
                const isHovered = taskDetailsPopup?.hoveredId === row?.issue_id;
                return <div className="d-flex justify-content-between align-items-center px-1" onMouseEnter={() => setTaskDetailsPopup((prev) => ({ ...prev, hoveredId: row?.issue_id }))} onMouseLeave={() => setTaskDetailsPopup((prev) => ({ ...prev, hoveredId: 0 }))}>
                    <div className={`d-flex gap-2 align-items-center ${isHovered ? "w90" : "w100"}`}>
                        <img src={row?.issue_type_image_url} alt="" width={16} height={16} />
                        <div className="c-pointer fw-semibold text-decoration-underline text-truncate" onClick={() => setTaskDetailsPopup((prev) => ({ ...prev, show: true, data: row }))}>{row?.issue_key}</div>
                    </div>
                    {isHovered && <a href={row?.issue_url} target="_blank" className="w10 text-secondary"><FontAwesomeIcon icon="fa-solid fa-link" /></a>}
                </div>
            }
        },
        {
            key: "issue_summary",
            label: "Task Name",
            style: { width: "50%", flex: 1 },
            render: (row) => {
                return (
                    <div className="text-truncate" title={row?.issue_summary}>{row?.issue_summary}</div>
                )
            }
        },
        {
            key: "time_left",
            label: "Time Left",
            style: { textAlign: "center", width: "8%" },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                return (
                    <div className={`${row?.time_left_seconds === 0 ? "text-danger fw-semibold" : ""}`}>{row?.time_left}</div>
                )
            }
        },
        {
            key: "bid_hours",
            label: "My Bid",
            style: { width: "10%", padding: 0 },
            headerStyle: { textAlign: "center" },
            sort: false,
            render: (row) => {
                const selectedBid = selectedData?.bid?.[row?.issue_id] !== undefined ? selectedData?.bid?.[row?.issue_id] : row?.bid_seconds || null
                return (
                    <div className="pe-1">
                        <Dropdown className="input-dd w100" filter filterInputAutoFocus value={selectedBid} onChange={(e) => { handleBidSave(row, e.target.value) }} placeholder=" " options={options?.bid_seconds} optionLabel="label" disabled={row?.time_left_seconds === 0} showClear />
                    </div>
                );
            },
        },
        {
            key: "time_matrix",
            label: "Time Matrix",
            style: { width: "7%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            hide: !commonFilter.taskType || getValuePermission("time_matrix_column"),
            render: (row) => {
                const range = _.find(options?.timeMatrix, (item) => parseInt(item?.complexity_id) === row?.complexity_id && parseInt(item?.longitivity_id) === row?.longitivity_id)
                return (
                    <p className="fw-bold">{range?.min_hours} - {range?.max_hours}</p>
                );
            }
        },
        {
            key: "time_matrix2",
            label: "My Matrix",
            style: { width: "7%", textAlign: "center" },
            headerStyle: { textAlign: "center" },
            hide: getValuePermission("time_matrix_column"),
            render: (row) => {
                return (
                    <p className="fw-bold">{row?.minBid} - {row?.maxBid}</p>
                );
            }
        },
        {
            key: "revoke",
            label: "Revoke",
            style: { width: "5%" },
            headerStyle: { textAlign: "center", paddingLeft: "10px" },
            hide: getValuePermission("agileplanning_estimation_send_to_review_btn"),
            sort: false,
            render: (row) => {
                return (
                    <div className="fs-6 text-danger text-center c-pointer" onClick={() => setRevoke((prev) => ({ ...prev, show: true, data: [row?.issue_id], product_code: row?.product_code }))}><FontAwesomeIcon icon="fa-solid fa-hand-point-left" /></div>
                )
            }
        },
    ]

    useEffect(() => {
        callautopopulate("projects", "bid_seconds", "time_matrix")?.then(res => {
            res?.bid_seconds?.forEach(item => {
                item.label = secondsToHours(item.bid_seconds);
                item.value = item?.bid_seconds
            });
            setOptions((prev) => ({ ...prev, projects: _.sortBy(res?.projects, "project_name"), bid_seconds: res?.bid_seconds, timeMatrix: res?.time_matrix, apiCall: true }));
        })
    }, [])

    useEffect(() => {
        !_.isEqual(commonFilter, filterValues) && setCommonFilter({ ...commonFilter, ...filterValues });
    }, [filterValues])

    useEffect(() => {
        !_.isEqual(commonFilter, filterValues) && setFilterValues((prev) => ({ ...prev, ...commonFilter }));
    }, [commonFilter])

    const menuItems = [{
        label: "Extend Bidding Time",
        items: timeOptions.map(item => ({
            ...item,
            command: (event) => {
                handleExtendTimeSave(event);
            }
        }))
    }];

    useEffect(() => {
        options?.apiCall && getEstimateDetails();
    }, [options?.apiCall])

    const getEstimateDetails = async () => {
        try {
            setLoader(true);
            const payload = {
                project_ids: commonFilter?.projects?.toString() || "",
                issue_types: commonFilter?.issueType?.toString() || "",
                issue_ids: commonFilter?.issueKey || ""
            }
            const res = await services.getInvokeRemote("POST", Urls("PGETBUCKETESTIMATEDETAILS"), payload);
            if (res) {
                const data = res?.body?.data?.bucket_estimate_detail;

                let bids = {};
                const grouped = {};
                _.sortBy(data, "issue_key")?.forEach(issue => {
                    const featureKey = issue?.features_issue_key;
                    if (featureKey) {
                        if (!grouped[featureKey]) {
                            grouped[featureKey] = {
                                id: featureKey,
                                title: issue?.features_issue_summary || featureKey,
                                children: []
                            };
                        }
                        grouped[featureKey].children.push(issue);
                        bids = { ...bids, [issue?.issue_id]: issue?.bid_seconds }
                    }
                });
                setRowData(Object.values(grouped));
                setSelectedData((prev) => ({ ...prev, bid: { ...prev?.bid, bids } }));
                setCommonFilter({ ...commonFilter, isChange: false, totalTasks: _.pluck(Object.values(grouped), "children")?.flatMap(item => item)?.length })
            }
        } catch (error) {
            console.error("Error: ", error);
        } finally {
            setLoader(false);
            setOptions((prev) => ({ ...prev, apiCall: false }))
        }
    }

    const handleBidSave = async (rowdata, val) => {
        try {
            const payload = {
                issue_id: rowdata?.issue_id || 0,
                product_code: rowdata?.product_code || 0,
                bid_seconds: val || 0
            }
            const res = await services.getInvokeRemote("POST", Urls("PUPSERTBUCKETESTIMATEBIDSAVE"), payload);
            if (res) {
                showSuccess("Success", res?.body?.message);
                setSelectedData((prev) => ({ ...prev, bid: { ...prev?.bid, [rowdata?.issue_id]: val || null } }));
            }
        } catch (error) {
            console.error("Error: ", error);
            showError("Error", error?.response?.data?.errorMessage);
        }
    }

    const handleExtendTimeSave = async (event) => {
        try {
            const payload = {
                issue_ids: _.pluck(selectedData?.issue, "issue_id").toString(),
                extend_hour: event?.item?.value,
            };
            const res = await services.getInvokeRemote("POST", Urls("PBUCKETESTIMATEEXTENDTIME"), payload);
            if (res?.status === 200 && res.body.data) {
                showSuccess('Sucess', res.body.message);
                getEstimateDetails();
                setSelectedData((prev) => ({ ...prev, issue: [] }));
            } else {
                showError("Error", res.body.errorMessage);
            }
        } catch (error) {
            console.error("Error: ", error);
        }
    }

    const handleFilterChange = async () => {
        const opts = await getSubProject(commonFilter?.projects, "is_issue_type", null);
        if (opts) {
            setProjectWiseData(opts)
            setOptions((prev) => ({ ...prev, apiCall: true }))
        }
    }

    const handleExtendTime = (e) => {
        if (_.isEmpty(selectedData?.issue)) {
            showInfo("Info", "No issues selected");
            return;
        } else if (_.some(selectedData?.issue, item => item?.time_left_seconds > 0)) {
            showInfo("Info", `You can't extend time for these issues because time is still left: ${_.pluck(_.filter(selectedData?.issue, item => item?.time_left_seconds > 0), "issue_key")?.join(", ")}`);
            return;
        } else {
            menuRef.current?.toggle(e);
        }
    }

    const handleRevoke = () => {
        if (_.isEmpty(selectedData?.issue)) {
            showInfo("Info", "No issues selected");
            return;
        } else {
            setRevoke((prev) => ({ ...prev, show: true, data: _.pluck(selectedData?.issue, "issue_id"), product_code: selectedData?.issue?.[0]?.product_code }));
        }
    }

    return useMemo(() => ({
        tagRef, options, getEstimateDetails, columns, rowData, loader, handleFilterChange, selectedData, setSelectedData, handleExtendTime, menuItems, menuRef, revoke, setRevoke, handleRevoke, setCommonFilter, commonFilter, projectWiseData, expanded, setExpanded, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup
    }), [tagRef, options, getEstimateDetails, columns, rowData, loader, handleFilterChange, selectedData, setSelectedData, handleExtendTime, menuItems, menuRef, revoke, setRevoke, handleRevoke, setCommonFilter, commonFilter, projectWiseData, expanded, setExpanded, filterValues, setFilterValues, taskDetailsPopup, setTaskDetailsPopup])
}